
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/gifts_page",
      function () {
        return require("private-next-pages/gifts/gifts_page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/gifts_page"])
      });
    }
  